import { render, staticRenderFns } from "./SelectRobotModal.vue?vue&type=template&id=3f5f0407&scoped=true&"
import script from "./SelectRobotModal.vue?vue&type=script&lang=js&"
export * from "./SelectRobotModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f5f0407",
  null
  
)

export default component.exports